import React, { useState, useEffect, Fragment } from "react";
//import Navigation from "./navigation";
import Footer from "./footer";

import Informe_2_detallado from "./monitor/informe_2_detallado";

const Mapas =  ({ setAuth, ...props }) => {  

  //***chequear token *** //24-06-2022

  const [name, setName] = useState("");
  const [role, setRole] = useState("user");

	const getProfile  = async  () => {
    try {
      const res = await fetch(`/api/authentication/checkAuth`, { //${baseURL}
      method: "POST",
      headers: { 'Authorization': localStorage.tokenT, roleT: localStorage.roleT, username:localStorage.username }
      });

      const parseRes = await res.json();      

      setName(parseRes.username);
			setRole(parseRes.role);
      

    } catch (err) {
    console.error(err.message);
    }
  };

  useEffect(() => {
      getProfile();
  }, []);
	//*** cierra chequear token ****//24-06-2022

  return (
    <Fragment>
      <div className="main">
        <h4 className="mt-5 text-center">Mapas</h4>
        <div>
          <Informe_2_detallado name={name} />
        </div>
      </div>
      <Footer />

    </Fragment>
  );
}

export default Mapas;